import { Component, Input } from '@angular/core';
import { UiStatCardVariant } from '../../models/ui-badge.model';

@Component({
  selector: 'app-ui-stat-card',
  templateUrl: './ui-stat-card.component.html',
  styleUrls: ['./ui-stat-card.component.scss']
})
export class UiStatCardComponent {
  @Input() label = '';
  @Input() value: string | number = 0;
  @Input() icon = 'description';
  @Input() variant: UiStatCardVariant = 'default';
}
